<input class="form-control" bsDatepicker
  [bsConfig]="{ isAnimated: true, adaptivePosition: true, containerClass:'theme-blue', displayOneMonthRange: true, selectFromOtherMonth:true }"
  [datesEnabled]="datesEnabled" [dateCustomClasses]="dateCustomClasses" [bsValue]="currentDate" placement="bottom"
  [minDate]="minDate" [maxDate]="maxDate" [formControl]="creditForm" name="creditCalendar" (bsValueChange)="handleChange($event)">
